import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NzNotificationRef, NzNotificationService} from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-toast',
  standalone: false,

  templateUrl: './toast.component.html',
  styleUrl: './toast.component.less'
})
export class ToastComponent {

  @Input() notRef!: NzNotificationRef;

  @Input() icon: string | undefined;
  @Input() iconColor: string | undefined
  @Input() content: string | undefined;
  @Input() msg: string | undefined;
  @Input() showUndo: boolean = true;

  constructor(private notificationService: NzNotificationService) {
  }

  close(): void {
    this.notificationService.remove(this.notRef.messageId);
  }

}
